import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CeiboShare } from 'ng2-social-share';



@NgModule({
    imports: [

    ],
    declarations: [
        CeiboShare
    ],
    entryComponents: [],
    exports: [
        CeiboShare
    ],
    schemas: [NO_ERRORS_SCHEMA]
})
export class CeiboShareModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/ceiboShare/ceiboShare.module.ts